import { Button } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { UseAppDispatch } from "redux/store";
import { searchFormSelector } from "redux/searchForm";
import { setEntireFilters, filterSelector } from "redux/filters";
import { changeSortType, sortSelector } from "redux/sort";
import { resetFilters } from "./resetFilters";
import { useMediaQuery, useTheme } from "@mui/material";
import { useTranslations } from "hooks/useTranslations";
import { pushToDataLayer, isDiff } from "@thekilroygroup/shared-ui";

function ClearFiltersButton() {
  const theme = useTheme();
  const allFilters = useSelector(filterSelector);
  const dispatch = UseAppDispatch();
  const searchForm = useSelector(searchFormSelector);
  const { sortType } = useSelector(sortSelector);
  const { translations } = useTranslations();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const clearFilters = () => {
    pushToDataLayer("Clear all filters", "Filter - Clear all");

    const { initialFilters, filters } = resetFilters(
      searchForm,
      allFilters,
      translations,
    );

    if (isDiff(initialFilters, filters)) {
      dispatch(setEntireFilters(initialFilters));
    }

    if (!isDesktop && sortType !== "penaltyPoints") {
      dispatch(changeSortType("penaltyPoints"));
    }
  };

  return (
    <Button variant="text" edge="end" onClick={clearFilters}>
      {translations.filters.clear}
    </Button>
  );
}

export default React.memo(ClearFiltersButton);
